"use client";

import { Box, Link, Typography } from "@mui/material";
import { usePostHog } from "posthog-js/react";

import { DynamicBlock } from "./DynamicBlock";
import type { PublisherBlogPost } from "../types/Publisher";

interface LastBoaSementeBlogPostContentProps {
  blog: PublisherBlogPost;
  postTagline: string | null;
}

export function LastBoaSementeBlogPostContent({
  blog,
  postTagline,
}: LastBoaSementeBlogPostContentProps) {
  const posthog = usePostHog();

  const blogUrl = new URL(blog.link);
  blogUrl.searchParams.append("utm_source", "leiturascristas");

  const handleBlogLinkClick = () => {
    posthog?.capture("publisher_blog_link_clicked", {
      blog_title: blog.title,
      blog_url: blogUrl.toString(),
    });
  };

  return (
    <DynamicBlock title={postTagline || "Novidade da Editora"}>
      <Link
        href={blogUrl.toString()}
        target="_blank"
        rel="noopener noreferrer"
        underline="none"
        color="textPrimary"
        onClick={handleBlogLinkClick}
        sx={{ display: "block", cursor: "pointer", "&:hover": { opacity: 0.8 } }}
      >
        <Box display="flex" alignItems="center" gap={1} sx={{ mb: 1 }}>
          <Typography variant="body1">{blog.title}</Typography>
        </Box>
        <Typography
          align="justify"
          variant="body2"
          color="textSecondary"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "4",
            WebkitBoxOrient: "vertical",
          }}
        >
          {blog.excerpt}
          ...
        </Typography>
      </Link>
    </DynamicBlock>
  );
}
